<template>
  <vis-modal
    :title="company.Name"
    :visible="modalShow"
    :toolbar="toolbar"
    @hide="hide"
    size="lg"
  >
    <b-modal
      :title="$t('validityReport')"
      class="modal-warning"
      v-model="validityReport.visible"
      @hide="validityReport.visible = false"
      hide-footer
    >
      <b-alert show variant="danger">{{ $t("validationErrors") }}</b-alert>
      <b-alert show variant="warning">
        <ul>
          <li v-for="(item, index) in validityReport.items" :key="`item_${index}`">
            <div class="my-1" v-if="item.messages">
              <div>{{ item.label }} :</div>
              <div
                class="ml-2"
                v-for="(message, index) in item.messages"
                :key="`message_${index}`"
              >
                - {{ message }}
              </div>
            </div>
            <div v-else>{{ item.label }} : {{ item.message }}</div>
          </li>
        </ul>
      </b-alert>
    </b-modal>

    <div
      v-for="(element, name) in schema" :key="name">
      <vis-editor-dv-element
        :editor="element.editor"
        :component="element.component"
        :element="element.element"
        @checkValid="checkValid"
        @change="(e) => onChange(name, e)"
      />
    </div>

    <vis-confirm-dialog
      :visible="confirmDialog.visible"
      :title="confirmDialog.title"
      :text="confirmDialog.text"
      @acceptChanges="onAcceptConfirmDialog"
      @cancelChanges="closeConfirmDialog"
      @hideDialog="closeConfirmDialog"
    />

  </vis-modal>
</template>

<script>
import paymentApi from "@/api/payment-api";
import ModalShow from "@/mixins/modal-show";
import errorMessage from "@/shared/error-message";
import confirmDialog from '@/mixins/confirm-dialog';

export default {
  name: "vis-edit-company-form",
  mixins: [ ModalShow, confirmDialog ],
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  data(vm) {
    return {
      schema: {
        MerchantId: {
          editor: {
            Name: "MerchantId",
            Required: true,
            value: null,
          },
          element: {
            LabelVisible: true,
            TextAlign: 'left',
            Text: vm.$t('payment.merchantId'),
          },
          component: { Name: 'String' }
        },
        CallbackSecret: {
          editor: {
            Name: "CallbackSecret",
            Required: true,
            value: null,
          },
          element: {
            LabelVisible: true,
            TextAlign: 'left',
            Text: vm.$t('payment.callbackSecret'),
          },
          component: { Name: 'String' }
        },
      },
      toolbar: [{
        id: "save-buttons",
        type: "button-group",
        position: "right",
        buttons: [
          {
            type: "button",
            text: "Save",
            variant: "success",
            onClick: vm.save,
          },
          {
            type: "button",
            text: "SaveAndClose",
            variant: "primary",
            onClick: vm.saveAndClose,
          }
        ]
      }],
      companyId: null,
      validityReport: {
        visible: false,
        items: {},
      }
    }
  },
  async mounted() {
    this.bindSchema()
  },
  methods: {
    bindSchema() {
      if (this.company) {
        this.companyId = this.company.Id
        Object.keys(this.company).forEach(field => {
          if (this.schema[field]) {
            this.schema[field].editor.value = this.company[field]
          }
        })
      }
    },
    checkValid(e) {
      if (this.schema[e.sender.Name]) {
        let editor = this.schema[e.sender.Name]
        editor.valid = e.valid

        if (e.valid === false) {
          let message = e.errorMessage || this.$t("validationErrorMessages.requiredField")
          this.validityReport.items[e.sender.Name] = {
            label: editor.element.Text,
            message,
          };
        } else {
          if (Object.hasOwnProperty.call(this.validityReport.items, e.sender.Name)) {
            delete this.validityReport.items[e.sender.Name];
          }
        }
      }
    },
    async save() {
      if (this.hasErrors()) {
        this.validityReport.visible = true;
        return;
      }
      await this.updateCompany()
    },
    async saveAndClose() {
      await this.save()
      this.hide()
    },
    async updateCompany() {
      if (!this.dirty) return this.$visNotification.info(this.$t("detailView.notifications.dataNotChanged"));

      const companyModel = {
        MerchantId: this.schema.MerchantId.editor.value,
        CallbackSecret: this.schema.CallbackSecret.editor.value
      }

      try {
        this.company = await paymentApi.editCompany(this.companyId, companyModel)
        this.bindSchema()
        this.$visNotification.success(this.$t("detailView.notifications.saved"));
      } catch(err) {
        this.showErrorMessage(err)
      }
      this.dirty = false
    },
    hasErrors() {
      return Object.keys(this.validityReport.items).length !== 0
    },
    hide(e) {
      if (this.dirty) {
        e.preventDefault()
        return this.openConfirmDialog(this.confirmDialogs.unsavedChanges)
      }
      this.$emit('hide');
    },
    onChange(field, e) {
      this.schema[field].editor.value = e.value;
      this.dirty = true
    },
    async showErrorMessage(err) {
      let error = await errorMessage(err);
      this.$visNotification.show(error.title, error.message, "danger");
    }
  }
}
</script>
